import api from "./api";

const scheduleExceptionService = {
    list: async ({ professionalId }) => {
        const { data } = await api.get(`/professionals/${professionalId}/exceptions`);
        return data;
    },

    save: async ({ professionalId, date, startTime, endTime, type, schedules }) => {
        const { data } = await api.post(`/professionals/${professionalId}/exceptions`, {
            date,
            startTime,
            endTime,
            type,
            schedules
        });
        return data;
    },

    bulkSave: async ({ professionalId, startDate, endDate, startTime, endTime, weekdays, type, schedules }) => {
        const { data } = await api.post(`/professionals/${professionalId}/exceptions/bulk`, {
            startDate,
            endDate,
            startTime,
            endTime,
            weekdays,
            type,
            schedules
        });
        return data;
    },

    delete: async (exceptionId) => {
        const { data } = await api.delete(`/professionals/exceptions/${exceptionId}`);
        return data;
    },
};

export default scheduleExceptionService;
